export default __webpack_public_path__ + "static/media/Animals02.6b5cd368.jpg";